module.exports = __webpack_public_path__ + "img/card8.75d9453e.png";